import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  Grid,
  MenuItem,
  Select,
  Typography,
  TextField,
  FormControl,
  Radio,
  TextareaAutosize,
  OutlinedInput,
  Chip,
  Icon,
} from "@mui/material";
import dayjs from 'dayjs'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import WarningDialog from "../../../components/WarningConfirm";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom'
import React, { useEffect, useRef } from "react";
import { getCategoryWeight, postCreateMyGoal } from "../../../actions/mygoal";

import { ReactComponent as BackIcon } from "../../../icons/arrow-left.svg";
import { ReactComponent as SaveIcon } from "../../../icons/save-btn-icon.svg";
import { ReactComponent as CloseIcon } from "../../../icons/close-btn-icon.svg";
import { ReactComponent as LinkActive } from "../../../icons/link-goal-active.svg";
import { ReactComponent as LinkInactive } from "../../../icons/link-goal-inactive.svg";
import { ReactComponent as CasActive } from "../../../icons/cas-active.svg";
import { ReactComponent as CasInactive } from "../../../icons/cas-inactive.svg";
import { ReactComponent as NoneAlignment } from "../../../icons/none-alignment.svg";

// import axios from "axios";
const MyGoalCreateResult = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const _ = require("lodash");
  const pageResult = window.location.pathname.indexOf('result') >= 0;
  const navigate = useNavigate();
  const { state } = useLocation();

  // ----------------------------------
  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
  };

  // Functions Start

  // Common Start
  const chooseLibrary = (val) => {
    setCancascading(val.options.cascading)
    if (typeEdit) {
      setGoalType(val.id)
    }
  }

  const chooseCategory = (val) => {
    if (categoryEdit) {
      setCategory(val)
      dispatch(getCategoryWeight(val))
        .then(resp => {
          if (resp.data.goalCategoryWeight.weight) {
            setCategoryWeight(100 - resp.data.goalCategoryWeight.weight);
          } else {
            setCategoryWeight(100)
          }
        })
    }
  }

  const goto = (route, data) => {
    if (route) {
      if (route === 'mygoal' && state.isEvaluator && state.formEvaluateId) route += '/' + state.formEvaluateId
      route = '/' + route
    }

    if (data) {
      navigate("/kpi" + route, { replace: false, state: data });
    } else {
      navigate("/kpi" + route, { replace: false });
    }
  }

  const isEmpty = (data) => {
    if (data == null || data == "" || data.length == 0) {
      return true
    } else
      return false
  }
  // Common End

  // Verify & Set Data Start
  const confirmPage = () => {
    if (pageResult) {
      var data = {
        goal_detail: {
          goal_name: goalName,
          goal_details: goalDetail,
          start_date: startDate,
          end_date: endDate,
          goal_metric: goalMetric,
          target_condition: condition,
          unit: unit,
          specify_unit: others,
          target_value: targetValue,
        },
        goal_category: {
          goal_category_id: goalCategory,
          evaluation_weight: weight,
        },
        scale_level: scaleLevel,
        goal_type: goalType,
        suggestion_type: null,
        goal_template_id: null,
        goal_member_id: null,
        goal_member: {
          team: memberType,
          include: member,
          exclude_member: null
        },
        evaluator_permission: {
          evaluator: evaluator?.code,
          permission: permission,
        },

      }
      if (goalAlignment == 1) {
        data = Object.assign(data, {
          linking_goal: {
            linking_goal_type: type,
            linking_goal: value
          }
        })
      } else {
        data = Object.assign(data, {
          cascade_goal: {
            assgined_type: type,
            assgined_members: value
          }
        })
      }
      dispatch(postCreateMyGoal(data))
        .then(resp => {
          if (resp.success) {
            goto('mygoal-create-success', state)
          }
        })
    } else {
      goto(`mygoal`, state)
    }
  }

  const handleChange = (value, type) => {
    var stateOption = { ...selectOption };
    if (type == 'evaluator') {
      setEvaluator(value === 'string' ? value.split(',') : value)
    } else if (type == 'metric') {
      setGoalMetric(value)
      if (value == 'Value') {
        setTargetValue("")
        setScaleCondition([
          { min_value: '1', max_value: '20' },
          { min_value: '21', max_value: '40' },
          { min_value: '41', max_value: '60' },
          { min_value: '61', max_value: '80' },
          { min_value: '81', max_value: '100' },
        ])
        if (respOption) {
          respOption.map((data) => {
            if (data.code == value.toLowerCase() && data.options != null) {
              var stateOptions = { ...selectOption }
              stateOptions['condition'] = data.options.target_condition.map((option) => option.label);
              setSelectOption(stateOptions)
            }
          })
        }
      } else if (value == 'Date') {
        setUnit(null)
        setCondition(null)
        setTargetValue(endDate != null ? dayjs(endDate).format('DD/MM/YYYY') : "")
        setScaleCondition([
          { min_value: '01/01/2020', max_value: '31/01/2020' },
          { min_value: '01/02/2020', max_value: '28/02/2020' },
          { min_value: '01/03/2020', max_value: '31/03/2020' },
          { min_value: '01/04/2020', max_value: '30/04/2020' },
          { min_value: '01/05/2020', max_value: '31/05/2020' },
        ])
      } else if (value == 'Accomplishment') {
        setUnit(null)
        setCondition(null)
        setTargetValue('Success')
      }
    } else if (type == 'unit') {
      setUnit(value)
      setScaleCondition([
        { min_value: '1', max_value: '20' },
        { min_value: '21', max_value: '40' },
        { min_value: '41', max_value: '60' },
        { min_value: '61', max_value: '80' },
        { min_value: '81', max_value: '100' },
      ])
      if (value == 'Minute') {
        setScaleCondition([
          { min_value: '1', max_value: '20' },
          { min_value: '21', max_value: '30' },
          { min_value: '31', max_value: '40' },
          { min_value: '41', max_value: '50' },
          { min_value: '51', max_value: '60' },
        ])
      } else if (value == 'Hours') {
        setScaleCondition([
          { min_value: '1', max_value: '4' },
          { min_value: '5', max_value: '8' },
          { min_value: '9', max_value: '12' },
          { min_value: '13', max_value: '16' },
          { min_value: '17', max_value: '24' },
        ])
      } else if (value == 'Score') {
        setScaleCondition([
          { min_value: '1', max_value: '200' },
          { min_value: '201', max_value: '400' },
          { min_value: '401', max_value: '600' },
          { min_value: '601', max_value: '800' },
          { min_value: '801', max_value: '1000' },
        ])
      }
    } else if (type == 'condition') {
      setCondition(value)
    } else if (type == 'memberType') {
      setMemberType(value)
      if (value == 'Team') {
        stateOption['member'] = memberTeamOption
      } else if (value == 'Member') {
        stateOption['member'] = memberOption
      }
      setMember([])
    } else if (type == 'member') {
      setMember(value)
    } else if (type == 'permission') {
      setPermission(value)
    } else if (type == 'type') {
      if (goalAlignment == 1) {
        stateOption['value'] = alignmentOption;
      } else if (goalAlignment == 2) {
        stateOption['value'] = value == 'Member' ? memberOption : memberTeamOption;
      }
      setType(value)
    } else if (type == 'value') {
      setValue(value)
    }

    setSelectOption(stateOption);
  };

  const changeValue = (value, type) => {
    var scaleLevelData = [...scaleLevel];
    if (type == 'name') {
      setGoalName(value)
    } else if (type == 'detail') {
      setGoalDetail(value)
    } else if (type == 'custom') {
      setOthers(value)
    } else if (type == 'targetValue') {
      setTargetValue(value)
    } else if (type == 'weight') {
      setWeight(value)
    } else if (type == 'scaleMin1') {
      scaleLevelData[0]['min_value'] = value
    } else if (type == 'scaleMax1') {
      if (new Date(value) < new Date(scaleLevelData[0]['min_value'])) {
        setOrderScale('desc');
      } else {
        setOrderScale('asc');
      }
      scaleLevelData[0]['max_value'] = value
    } else if (type == 'scaleMin2') {
      scaleLevelData[1]['min_value'] = value
    } else if (type == 'scaleMax2') {
      scaleLevelData[1]['max_value'] = value
    } else if (type == 'scaleMin3') {
      scaleLevelData[2]['min_value'] = value
    } else if (type == 'scaleMax3') {
      scaleLevelData[2]['max_value'] = value
    } else if (type == 'scaleMin4') {
      scaleLevelData[3]['min_value'] = value
    } else if (type == 'scaleMax4') {
      scaleLevelData[3]['max_value'] = value
    } else if (type == 'scaleMin5') {
      scaleLevelData[4]['min_value'] = value
    } else if (type == 'scaleMax5') {
      scaleLevelData[4]['max_value'] = value
    }
    setScaleLevel(scaleLevelData)
  }

  const valueCondition = () => {
    let text = ''
    if (unit == 'Percentage') {
      text = "0.00 - 100.00"
    } else if (unit == 'Minute') {
      text = "0.00 - 100.00"
    } else if (unit == 'Hour') {
      text = "0.00 - 100.00"
    } else if (unit == 'Day') {
      text = "0.00 - 100.00"
    } else if (unit == 'Score') {
      text = "0 - 1,000.00"
    } else if (unit == 'Client') {
      text = "0 - 100,000.00"
    } else if (unit == 'Count') {
      text = "0 - 100,000.00"
    } else if (unit == 'THB') {
      text = "0 - 1,000,000,000.00"
    } else if (unit == 'USD') {
      text = "0 - 1,000,000,000.00"
    } else if (unit == 'Others') {
      text = "0 - 1,000,000,000.00"
    }
    return <Typography style={{ fontSize: 14, color: '#A3A3A3' }}>{text}</Typography>
  }

  const changeAlignment = (val) => {
    if (val != goalAlignment) {
      var stateOption = { ...selectOption };
      setType([])
      setValue([])
      if (val == 1) {
        stateOption['type'] = ['Associated Goal', 'Parent Goal'];
        stateOption['value'] = alignmentOption;
      } else {
        stateOption['type'] = ['Member', 'Team'];
        stateOption['value'] = [];
      }
      setSelectOption(stateOption)
    }
    setGoalAlingment(val)
  }

  const addDate = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  const checkField = (type) => {
    var data = {}
    if (isEmpty(goalType)) {
      data = Object.assign(data, { goalType: true })
    }
    if (isEmpty(goalName)) {
      data = Object.assign(data, { name: true })
    }
    if (isEmpty(goalDetail)) {
      data = Object.assign(data, { detail: true })
    }
    if (isEmpty(startDate)) {
      data = Object.assign(data, { startDate: true })
    }
    if (isEmpty(endDate)) {
      data = Object.assign(data, { endDate: true })
    }
    if (isEmpty(goalMetric)) {
      data = Object.assign(data, { goalMetric: true })
    }
    if (goalMetric == 'Value') {
      if (isEmpty(condition)) {
        data = Object.assign(data, { condition: true })
      }
      if (isEmpty(unit)) {
        data = Object.assign(data, { unit: true })
      }
      if (isEmpty(targetValue)) {
        data = Object.assign(data, { targetValue: true })
      } else {
        const unitOption = selectOption['unitOption'].filter((item) => { if (item.code == unit.toLowerCase()) return item })[0]
        const min = unitOption.options.min;
        const max = unitOption.options.max;
        if (max) {
          if (targetValue < min || targetValue > max) {
            data = Object.assign(data, { targetValue: true })
          }
        } else {
          if (targetValue < min) {
            data = Object.assign(data, { targetValue: true })
          }
        }
      }
    }
    if (goalType != 2) {
      if (isEmpty(member)) {
        data = Object.assign(data, { member: true })
      }
      if (isEmpty(memberType)) {
        data = Object.assign(data, { memberType: true })
      }
    }
    if (isEmpty(weight)) {
      data = Object.assign(data, { weight: true })
    }
    if (goalMetric == 'Date') {
    } else if (goalMetric == 'Value') {
      if (numberNotOverlap(scaleLevel)) {
        data = Object.assign(data, { scaleLevel: true })
      }
    }

    console.log(data);
    if (type == 'typeEdit' && !data.goalType) {
      setTypeEdit(false)
    } else if (type == 'detailEdit'
      && (!data.name || !data.detail || !data.startDate || !data.endDate || !data.goalMetric || !data.condition || !data.unit || !data.targetValue)) {
      setDetailEdit(false)
    } else if (type == 'memberEdit' && (!data.member || !data.memberType)) {
      setMemberEdit(false)
    } else if (type == 'scaleEdit' && !data.scaleLevel) {
      setScaleEdit(false)
    } else if (type == 'categoryEdit' && !data.weight) {
      setCategoryEdit(false)
    } else if (type == 'evaluatorEdit') {
      setEvaluatorEdit(false)
    } else if (type == 'alignmentEdit') {
      setAlignmentEdit(false)
    }
    setVerifyField(data)
  }

  const numberNotOverlap = (scaleLevelList) => {
    var overlap = false;
    var orderScaleLevel = 'asc';
    scaleLevelList.map((scaleLevel, idx) => {
      if (scaleLevel.min == null || scaleLevel.max == null) {
        overlap = true;
      } else {
        if (idx == 0) {
          if (parseInt(scaleLevel.max) - parseInt(scaleLevel.min) > 0) {
            orderScaleLevel = 'asc';
            setOrderScale('asc')
          } else {
            orderScaleLevel = 'desc';
            setOrderScale('desc')
          }
        } else {
          if (orderScaleLevel == 'asc') {
            if (parseInt(scaleLevel.max) - parseInt(scaleLevel.min) < 0) {
              overlap = true;
            }
          } else {
            if (parseInt(scaleLevel.min) - parseInt(scaleLevel.max) < 0) {
              overlap = true;
            }
          }
        }
      }
    })
    if (orderScaleLevel = 'asc') {
      if (parseInt(scaleLevelList[1].min) - parseInt(scaleLevelList[0].max) <= 0 || parseInt(scaleLevelList[2].min) - parseInt(scaleLevelList[1].max) <= 0 ||
        parseInt(scaleLevelList[3].min) - parseInt(scaleLevelList[2].max) <= 0 || parseInt(scaleLevelList[4].min) - parseInt(scaleLevelList[3].max) <= 0
      ) {
        overlap = true;
      }
    } else {
      if (parseInt(scaleLevelList[1].min) - parseInt(scaleLevelList[0].max) > 0 || parseInt(scaleLevelList[2].min) - parseInt(scaleLevelList[1].max) > 0 ||
        parseInt(scaleLevelList[3].min) - parseInt(scaleLevelList[2].max) > 0 || parseInt(scaleLevelList[4].min) - parseInt(scaleLevelList[3].max) > 0
      ) {
        overlap = true;
      }
    }
    return overlap;
  }

  const handleConfirmApprove = (val) => {
    openApproveDialog(false);
    goto('mygoal-choose-create', state)
  }

  const handleConfirmApproveDialog = (val) => {
    openApproveDialog(val);
  }

  const cancelField = (type) => {
    if (type == 'typeEdit') {
      setGoalType(oldData['goal_type'])
      setTypeEdit(false)
    } else if (type == 'detailEdit') {
      var goalDetail = oldData['goal_detail'];
      setGoalName(goalDetail['goal_name'])
      setGoalDetail(goalDetail['goal_details'])
      setStartDate(goalDetail['start_date'])
      setEndDate(goalDetail['end_date'])
      setGoalMetric(goalDetail['goal_metric'])
      setCondition(goalDetail['target_condition'])
      setUnit(goalDetail['unit'])
      setOthers(goalDetail['specify_unit'])
      setTargetValue(goalDetail['target_value'])
      setDetailEdit(false)
    } else if (type == 'memberEdit') {
      var goalMember = oldData['goal_member'];
      setMemberType(goalMember['team'])
      setMember(goalMember['include'])
      setMemberEdit(false)
    } else if (type == 'scaleEdit') {
      setScaleLevel(oldData['scale_level'])
      setScaleEdit(false)
    } else if (type == 'categoryEdit') {
      var goalCategory = oldData['goal_category'];
      setCategory(goalCategory['goal_category_id'])
      setWeight(goalCategory['evaluation_weight'])
      setCategoryWeight(goalCategory['category_weight'])
      setCategoryEdit(false)
    } else if (type == 'evaluatorEdit') {
      var evaluatorPermission = oldData['evaluator_permission'];
      setEvaluator(evaluatorPermission['evaluatorObject'])
      setPermission(evaluatorPermission['permission'])
      setEvaluatorEdit(false)
    } else if (type == 'alignmentEdit') {
      var alignment = oldData['alignment'];
      if (alignment == 1) {
        var linkingGoal = oldData['linking_goal'];
        setType(linkingGoal['linking_goal_type'])
        setValue(linkingGoal['linking_goal'])
      } else {
        var cascadeGoal = oldData['cascade_goal'];
        setType(cascadeGoal['assgined_type'])
        setValue(cascadeGoal['assgined_members'])
      }
      setAlignmentEdit(false)
    }
  }

  const editClick = (typeEdit) => {
    var oldDataObject = { ...oldData }
    if (typeEdit == 'typeEdit') {
      Object.assign(oldDataObject, {
        goal_type: goalType
      })
      setTypeEdit(true)
    } else if (typeEdit == 'detailEdit') {
      Object.assign(oldDataObject, {
        goal_detail: {
          goal_name: goalName,
          goal_details: goalDetail,
          start_date: startDate,
          end_date: endDate,
          goal_metric: goalMetric,
          target_condition: condition,
          unit: unit,
          specify_unit: others,
          target_value: targetValue,
        },
      })
      setDetailEdit(true)
    } else if (typeEdit == 'memberEdit') {
      Object.assign(oldDataObject, {
        goal_member: {
          team: memberType,
          include: member,
          exclude_member: null
        },
      })
      setMemberEdit(true)
    } else if (typeEdit == 'scaleEdit') {
      Object.assign(oldDataObject, {
        scale_level: scaleLevel.map((item) => { return { ...item } }),
      })
      setScaleEdit(true)
    } else if (typeEdit == 'categoryEdit') {
      Object.assign(oldDataObject, {
        goal_category: {
          goal_category_id: goalCategory,
          evaluation_weight: weight,
          category_weight: categoryWeight,
        }
      })
      setCategoryEdit(true)
    } else if (typeEdit == 'evaluatorEdit') {
      Object.assign(oldDataObject, {
        evaluator_permission: {
          evaluatorObject: evaluator,
          evaluator: evaluator?.code,
          permission: permission,
        }
      })
      setEvaluatorEdit(true)
    } else if (typeEdit == 'alignmentEdit') {
      if (goalAlignment == 1) {
        Object.assign(oldDataObject, {
          alignment: goalAlignment,
          linking_goal: {
            linking_goal_type: type,
            linking_goal: value
          }
        })
      } else {
        Object.assign(oldDataObject, {
          alignment: goalAlignment,
          cascade_goal: {
            assgined_type: type,
            assgined_members: value
          }
        })
      }
      setAlignmentEdit(true)
    }
    setOldData(oldDataObject);
  }
  // Verify & Set Data End

  // Functions End

  // Variable Start
  const [verifyField, setVerifyField] = React.useState({})
  const [goalType, setGoalType] = React.useState(null)
  const [goalCategory, setCategory] = React.useState(null)
  const [goalAlignment, setGoalAlingment] = React.useState(null)
  const [goalName, setGoalName] = React.useState(null)
  const [goalDetail, setGoalDetail] = React.useState(null)
  const [startDate, setStartDate] = React.useState(null)
  const [endDate, setEndDate] = React.useState(null)
  const [targetValue, setTargetValue] = React.useState(null)
  const [weight, setWeight] = React.useState(null)
  const [others, setOthers] = React.useState(null)
  const [evaluator, setEvaluator] = React.useState(null)
  const [goalMetric, setGoalMetric] = React.useState(null)
  const [unit, setUnit] = React.useState(null)
  const [condition, setCondition] = React.useState(null)
  const [memberType, setMemberType] = React.useState(null)
  const [member, setMember] = React.useState(null)
  const [permission, setPermission] = React.useState(null)
  const [type, setType] = React.useState(null)
  const [value, setValue] = React.useState([]);
  const [scaleLevel, setScaleLevel] = React.useState([
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
  ])
  const [categoryWeight, setCategoryWeight] = React.useState(0)
  const [canCascading, setCancascading] = React.useState(false)
  const [orderScale, setOrderScale] = React.useState('asc');
  const [selectOption, setSelectOption] = React.useState({
    permission: ['Private', 'Line', 'Team'],
    goalMetric: [],
    goalType: [],
    condition: [],
    unit: [],
    evaluator: [],
    member: [],
    memberType: [],
    permission: [],
    type: ['1', '2', '3'],
    value: ['1', '2', '3'],
  })
  const [scaleCondition, setScaleCondition] = React.useState([
    { min_value: '1', max_value: '20' },
    { min_value: '21', max_value: '40' },
    { min_value: '41', max_value: '60' },
    { min_value: '61', max_value: '80' },
    { min_value: '81', max_value: '100' },
  ])
  const [typeEdit, setTypeEdit] = React.useState(false);
  const [detailEdit, setDetailEdit] = React.useState(false);
  const [scaleEdit, setScaleEdit] = React.useState(false);
  const [memberEdit, setMemberEdit] = React.useState(false);
  const [categoryEdit, setCategoryEdit] = React.useState(false);
  const [alignmentEdit, setAlignmentEdit] = React.useState(false);
  const [evaluatorEdit, setEvaluatorEdit] = React.useState(false);
  const [respOption, setRespOption] = React.useState(null)
  const [goalCategoryOptions, setGoalCategoryOptions] = React.useState([])
  const [memberTeamOption, setMemberTeamOption] = React.useState([])
  const [memberOption, setMemberOption] = React.useState([])
  const [alignmentOption, setAlignmentOption] = React.useState([])
  const [isApproveDialogOpen, openApproveDialog] = React.useState(false);
  const [oldData, setOldData] = React.useState({})
  // Variable End

  useEffect(() => {
    if (state) {
      setMemberType(state.memberType);
      setGoalName(state.goalName);
      setGoalDetail(state.goalDetail);
      setGoalAlingment(state.alignment);
      setCondition(state.condition);
      setEvaluator(state.evaluator);
      setCategory(state.goalCategory);
      setStartDate(state.startDate);
      setEndDate(state.endDate);
      setGoalType(state.goalType);
      setMember(state.member);
      setOthers(state.others);
      setPermission(state.permission);
      setTargetValue(state.targetValue);
      setType(state.type);
      setUnit(state.unit);
      setValue(state.value);
      setWeight(state.weight);
      setScaleLevel(state.scaleLevel);
      setGoalMetric(state.goalMetric);
      setCategoryWeight(state.categoryWeight)
      setSelectOption(state.selectOption)
      setGoalCategoryOptions(state.goalCategoryOptions)
      setMemberTeamOption(state.memberTeamOption)
      setMemberOption(state.memberOption)
      setAlignmentOption(state.alignmentOption)
    }
  }, [])

  const requireField = (text) => {
    return (
      <Grid container direction="row">
        <Grid>
          <Typography>{text}</Typography>
        </Grid>
        <Grid>
          <Typography style={{ color: 'red' }}>&nbsp;*</Typography>
        </Grid>
      </Grid>)
  }

  return (
    <>
      <Helmet>
        <title>MyGoal | KPI </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => goto('kpi/home')}>
                {t('label.home')}
              </span> /
              <span style={styles.link} onClick={() => goto('mygoal', state)}>
                {` ${t('mygoal.page.mygoal')}`}
              </span> /
              <span style={styles.end} >
                {` ${t('mygoal.page.createGoal')}`}
              </span>
            </Typography>
          </Grid>

          <Grid container textAlign="center">
            <Grid item md={12} >
              <Typography variant="h1" fontSize={36} lineHeight="39.6px" fontWeight="500">
                {pageResult ? 'Review' : 'Edit Goal Item'}
              </Typography>
            </Grid>
            <Grid item md={12} pr={1} mt={1} mb={3}>
              <Typography fontSize={16}>
                {pageResult ? 'Review your goal details as the final step.' : 'Edit your goal item for the best match with your activities.'}
              </Typography>
            </Grid>
          </Grid>
          <Box backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 50 }} mb={3}>
            <Grid container justifyContent="space-between">
              <Grid item mb={2}>
                <Typography fontSize={22} fontWeight={600}>
                  {t("mygoal.label.labelGoalType")}
                </Typography>
              </Grid>
              {typeEdit
                ?
                <Grid>
                  <Button
                    size="small"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={() => cancelField('typeEdit')}
                    color="red"
                    variant="contained"
                    style={{ marginRight: '10px', textTransform: 'none' }}
                  >
                    <CloseIcon />
                    <Typography ml={1}>{t("mygoal.label.cancel")}</Typography>
                  </Button>
                  <Button
                    size="small"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    color="primary"
                    variant="contained"
                    style={{ marginRight: '10px', textTransform: 'none' }}
                    onClick={() => checkField('typeEdit')}
                  >
                    <SaveIcon />
                    <Typography ml={1}>{t("mygoal.label.save")}</Typography>
                  </Button>
                </Grid>
                :
                <Grid item mb={2} style={{ cursor: 'pointer' }} onClick={() => editClick('typeEdit')}>
                  <Typography color="primary">
                    {t("mygoal.label.edit")}
                  </Typography>
                </Grid>
              }
            </Grid>
            <Grid container spacing={2}>
              {!typeEdit ?
                selectOption.goalType.map((item, idx) => {
                  return (
                    goalType == item.id &&
                    <Grid lg={2} xs={12} key={idx} item>
                      <Card style={goalType == item.id ? { border: '1px solid #5DA196' } : { border: null } && typeEdit ? { cursor: 'pointer' } : { cursor: 'not-allowed' }} onClick={() => { chooseLibrary(item) }}>
                        <CardContent>
                          <Grid item lg={12} xs={12} container textAlign="center">
                            <Grid item>
                              <Radio name="radio" value="1" checked={goalType === item.id} size="small" />
                            </Grid>
                            <Grid item lg={12}>
                              <Icon style={{ color: item?.options?.color || '#FFF', fontSize: 40 }}>{item?.options?.icon}</Icon>
                              {/* <PersonalIcon className={goalType === item.id ? classes.activeIcon : classes.inactiveIcon} /> */}
                            </Grid>
                            <Grid item lg={12} mt={3}>
                              <Typography fontSize={16} lineHeight="21px" fontWeight="600">
                                {item.description}
                              </Typography>
                            </Grid>
                            <Grid item lg={12} mt={2}>
                              <Typography fontSize={12} variant="label">
                                {item.description}
                              </Typography>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  )
                })
                :
                selectOption.goalType.map((item, idx) => {
                  return (
                    <Grid lg={2} xs={12} key={idx} item>
                      <Card style={goalType == item.id ? { border: '1px solid #5DA196' } : { border: null } && typeEdit ? { cursor: 'pointer' } : { cursor: 'not-allowed' }} onClick={() => { chooseLibrary(item) }}>
                        <CardContent>
                          <Grid item lg={12} xs={12} container textAlign="center">
                            <Grid item>
                              <Radio name="radio" value="1" checked={goalType === item.id} size="small" />
                            </Grid>
                            <Grid item lg={12}>
                              <Icon style={{ color: item.options.color, fontSize: 40 }}>{item.options.icon}</Icon>
                              {/* <PersonalIcon className={goalType === item.id ? classes.activeIcon : classes.inactiveIcon} /> */}
                            </Grid>
                            <Grid item lg={12} mt={3}>
                              <Typography fontSize={16} lineHeight="21px" fontWeight="600">
                                {item.description}
                              </Typography>
                            </Grid>
                            <Grid item lg={12} mt={2}>
                              <Typography fontSize={12} variant="label">
                                {item.description}
                              </Typography>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  )
                })
              }
            </Grid>
          </Box>
          <Box backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 55 }} mb={3}>
            <Grid container justifyContent="space-between">
              <Grid item mb={2}>
                <Typography fontSize={22} fontWeight={600}>
                  {t("mygoal.label.labelGoalDetail")}
                </Typography>
              </Grid>
              {detailEdit
                ?
                <Grid>
                  <Button
                    size="small"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={() => cancelField('detailEdit')}
                    color="red"
                    variant="contained"
                    style={{ marginRight: '10px', textTransform: 'none' }}
                  >
                    <CloseIcon />
                    <Typography ml={1}>{t("mygoal.label.cancel")}</Typography>
                  </Button>
                  <Button
                    size="small"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    color="primary"
                    variant="contained"
                    style={{ marginRight: '10px', textTransform: 'none' }}
                    onClick={() => checkField('detailEdit')}
                  >
                    <SaveIcon />
                    <Typography ml={1}>{t("mygoal.label.save")}</Typography>
                  </Button>
                </Grid>
                :
                <Grid item mb={2} style={{ cursor: 'pointer' }} onClick={() => editClick('detailEdit')}>
                  <Typography color="primary">
                    {t("mygoal.label.edit")}
                  </Typography>
                </Grid>
              }
            </Grid>
            <Grid container spacing={2}>
              <Grid lg={12} xs={12} item>
                <Typography>
                  {requireField(t("mygoal.label.goalName"))}
                </Typography>
              </Grid>
              <Grid lg={12} item>
                <TextField error={verifyField.name} onChange={(e) => changeValue(e.target.value, 'name')} value={goalName} id="outlined-basic" placeholder="Fill your goal name" variant="outlined" required fullWidth size="small" disabled={!detailEdit} />
              </Grid>
              <Grid lg={12} xs={12} item>
                <Typography>
                  {requireField(t("mygoal.label.goalDetail"))}
                </Typography>
              </Grid>
              <Grid lg={12} item>
                <TextareaAutosize
                  fullWidth
                  aria-label="minimum height"
                  minRows={4}
                  placeholder="Describe your goal details"
                  style={{ width: '100%', borderColor: '#DCDCDC', padding: '10px' }}
                  disabled={!detailEdit}
                  value={goalDetail}
                  onChange={(e) => changeValue(e.target.value, 'detail')}
                />
              </Grid>
              <Grid lg={6} xs={12} item>
                {requireField(t("mygoal.label.startDate"))}
              </Grid>
              <Grid lg={6} xs={12} item>
                {requireField(t("mygoal.label.endDate"))}
              </Grid>
              <Grid lg={6} xs={12} item>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    value={startDate}
                    onChange={(newValue) => {
                      setStartDate(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                    label="Select start date"
                    disabled={!detailEdit}
                    format="dd/MM/yyyy"
                  />
                </LocalizationProvider>
              </Grid>
              <Grid lg={6} xs={12} item>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    value={endDate}
                    onChange={(newValue) => {
                      if (goalMetric == 'Date') {
                        setTargetValue(dayjs(newValue).format('DD/MM/YYYY'))
                      }
                      setEndDate(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                    label="Select end date"
                    disabled={!detailEdit}
                    format="dd/MM/yyyy"
                  />
                </LocalizationProvider>
              </Grid>
              <Grid lg={6} xs={12} item>
                {requireField(t("mygoal.label.goalMetric"))}
              </Grid>
              <Grid lg={6} xs={12} item>
                {requireField(t("mygoal.label.targetCondition"))}
              </Grid>
              <Grid lg={6} item>
                <FormControl sx={{ m: 1, minWidth: 80 }} fullWidth>
                  <Select
                    displayEmpty
                    error={verifyField.goalMetric}
                    labelId="metric"
                    id="metric"
                    value={goalMetric}
                    onChange={(val) => { handleChange(val.target.value, 'metric') }}
                    input={<OutlinedInput size="small" />}
                    renderValue={(selected) => {
                      if (selected == null) {
                        return <em>Select how you measure the activity</em>;
                      } else {
                        return selected
                      }
                    }}
                    disabled={!detailEdit}
                  >
                    <MenuItem disabled value="">
                      <em>Select how you measure the activity</em>
                    </MenuItem>
                    {selectOption.goalMetric.map((option, idx) => {
                      return <MenuItem key={idx} value={option}>{option}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid lg={6} item>
                <FormControl sx={{ m: 1, minWidth: 80 }} fullWidth>
                  <Select
                    displayEmpty
                    error={verifyField.condition}
                    labelId="condition"
                    id="condition"
                    value={condition}
                    onChange={(val) => { handleChange(val.target.value, 'condition') }}
                    input={<OutlinedInput size="small" />}
                    disabled={!detailEdit}
                    renderValue={(selected) => {
                      if (selected == null) {
                        return <em>Select the target condition</em>;
                      } else {
                        return selected
                      }
                    }}
                  >
                    <MenuItem disabled value="">
                      <em>Select the target condition</em>
                    </MenuItem>
                    {selectOption.condition.map((option, idx) => {
                      return <MenuItem key={idx} value={option}>{option}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid lg={6} xs={12} item>
                {requireField(t("mygoal.label.unit"))}
              </Grid>
              <Grid lg={4} xs={12} item>
                {requireField(t("mygoal.label.targetValue"))}
              </Grid>
              <Grid lg={2} xs={12} item style={{ textAlign: 'right', alignItems: 'flex-end' }}>
                {valueCondition()}
              </Grid>
              <Grid lg={6} item>
                <FormControl sx={{ m: 1, minWidth: 80 }} fullWidth>
                  <Select
                    displayEmpty
                    error={verifyField.unit}
                    labelId="unit"
                    id="unit"
                    value={unit}
                    onChange={(val) => { handleChange(val.target.value, 'unit') }}
                    input={<OutlinedInput size="small" />}
                    renderValue={(selected) => {
                      if (selected == null) {
                        return <em>Select the target unit</em>;
                      } else {
                        return selected
                      }
                    }}
                    disabled={!detailEdit}
                  >
                    <MenuItem disabled value="">
                      <em>Select the target unit</em>
                    </MenuItem>
                    {selectOption.unit.map((option, idx) => {
                      return <MenuItem key={idx} value={option}>{option}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid lg={6} item>
                <TextField id="outlined-basic" value={targetValue} onChange={(e) => changeValue(e, 'targetValue')} placeholder="Fill the target value" variant="outlined" required fullWidth size="small" style={{ marginLeft: 10, marginTop: 8 }} disabled={!detailEdit} />
              </Grid>
            </Grid>
            {unit == 'Other' &&
              <Grid lg={6} container direction="row" style={{ paddingRight: '10px' }}>
                <Grid item lg={2} alignSelf="center">
                  <Typography fontSize={14}>
                    {requireField(t("mygoal.label.specify"))}
                  </Typography>
                </Grid>
                <Grid item lg={10}>
                  <TextField id="others" placeholder="Specify how you measure the activity" variant="outlined" value={others} onChange={(e) => changeValue(e.target.value, 'others')} required fullWidth size="small" style={{ marginLeft: 10, marginTop: 8 }} disabled={!detailEdit || goalMetric != 'Value'} />
                </Grid>
              </Grid>
            }
          </Box>
          {(goalType == 1 || goalType == 2) &&
            <Box backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 50 }} mb={3}>
              <Grid container justifyContent="space-between">
                <Grid item mb={2}>
                  <Typography fontSize={22} fontWeight={600}>
                    {t("mygoal.label.goalMember")}
                  </Typography>
                </Grid>
                {memberEdit
                  ?
                  <Grid>
                    <Button
                      size="small"
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={() => cancelField('memberEdit')}
                      color="red"
                      variant="contained"
                      style={{ marginRight: '10px', textTransform: 'none' }}
                    >
                      <CloseIcon />
                      <Typography ml={1}>{t("mygoal.label.cancel")}</Typography>
                    </Button>
                    <Button
                      size="small"
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      color="primary"
                      variant="contained"
                      style={{ marginRight: '10px', textTransform: 'none' }}
                      onClick={() => checkField('memberEdit')}
                    >
                      <SaveIcon />
                      <Typography ml={1}>{t("mygoal.label.save")}</Typography>
                    </Button>
                  </Grid>
                  :
                  <Grid item mb={2} pr={4} style={{ cursor: 'pointer' }} onClick={() => editClick('memberEdit')}>
                    <Typography color="primary">
                      {t("mygoal.label.edit")}
                    </Typography>
                  </Grid>
                }
              </Grid>
              <Grid container spacing={2}>
                <Grid lg={12} xs={12} item>
                  <Typography>
                    {requireField("Goal member type")}
                  </Typography>
                </Grid>
                <Grid lg={12} xs={12} item>
                  <FormControl sx={{ m: 1, minWidth: 80 }} fullWidth>
                    <Select
                      displayEmpty
                      error={verifyField.memberType}
                      labelId="demo-simple-select-autowidth-label"
                      id="demo-simple-select-autowidth"
                      value={memberType}
                      onChange={(val) => { handleChange(val.target.value, 'memberType') }}
                      input={<OutlinedInput size="small" />}
                      renderValue={(selected) => {
                        if (selected == null) {
                          return <em>Select your goal member type</em>;
                        } else {
                          return selected
                        }
                      }}
                      disabled={!memberEdit}
                    >
                      <MenuItem disabled value="">
                        <em>Select your goal member type</em>
                      </MenuItem>
                      {selectOption.memberType.map((option, idx) => {
                        return <MenuItem key={idx} value={option}>{option}</MenuItem>
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid lg={12} xs={12} item>
                  <Typography>
                    {requireField(t("mygoal.label.goalMember"))}
                  </Typography>
                </Grid>
                <Grid lg={12} xs={12} item>
                  <FormControl sx={{ m: 1, minWidth: 80 }} fullWidth>
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-autowidth-label"
                      id="demo-simple-select-autowidth"
                      error={verifyField.member}
                      value={member}
                      multiple
                      onChange={(val) => { handleChange(val.target.value, 'member') }}
                      input={<OutlinedInput size="small" />}
                      renderValue={(selected) => {
                        if (selected.length == 0) {
                          return <em>Select your goal member</em>;
                        } else {
                          return <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {selected.map((value, idx) => (
                              <Chip key={idx} label={`${value.firstName} ${value.lastName ?? ''}`} style={{ borderRadius: '6px', backgroundColor: '#5DA196', color: 'white' }} />
                            ))}
                          </Box>
                        }
                      }}
                      disabled={!memberEdit}
                    >
                      <MenuItem disabled value="">
                        <em>Select your goal member</em>
                      </MenuItem>
                      {selectOption.member.map((option, idx) => {
                        return <MenuItem key={idx} value={option}>
                          {option.firstName} {option.lastName}
                        </MenuItem>
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid lg={12} xs={12} item>
                  <Typography fontSize={14} variant="label">
                    Select goal member: {member.length} member
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          }
          {goalMetric != 'Accomplishment' &&
            <Box backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 50 }} mb={3}>
              <Grid container justifyContent="space-between">
                <Grid item mb={2}>
                  <Typography fontSize={22} fontWeight={600}>
                    {t("mygoal.label.scaleLevel")}
                  </Typography>
                  <Typography>
                    {t("mygoal.label.scaleLevelSub")}
                  </Typography>
                </Grid>
                {scaleEdit
                  ?
                  <Grid>
                    <Button
                      size="small"
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={() => cancelField('scaleEdit')}
                      color="red"
                      variant="contained"
                      style={{ marginRight: '10px', textTransform: 'none' }}
                    >
                      <CloseIcon />
                      <Typography ml={1}>{t("mygoal.label.cancel")}</Typography>
                    </Button>
                    <Button
                      size="small"
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      color="primary"
                      variant="contained"
                      style={{ marginRight: '10px', textTransform: 'none' }}
                      onClick={() => checkField('scaleEdit')}
                    >
                      <SaveIcon />
                      <Typography ml={1}>{t("mygoal.label.save")}</Typography>
                    </Button>
                  </Grid>
                  :
                  <Grid item mb={2} style={{ cursor: 'pointer' }} onClick={() => editClick('scaleEdit')}>
                    <Typography color="primary">
                      {t("mygoal.label.edit")}
                    </Typography>
                  </Grid>
                }
              </Grid>
              <Grid container spacing={2} style={{ border: '1px solid #DADADA', paddingLeft: '30px', paddingRight: '30px', paddingBottom: '13px' }} mt={3}>
                <Grid md={2} item textAlign="center">
                  <Typography variant="label">
                    {t("mygoal.label.level")}
                  </Typography>
                </Grid>
                <Grid md={2} item></Grid>
                <Grid md={3} item textAlign="center">
                  <Typography variant="label">
                    {t("mygoal.label.actualMin")}
                  </Typography>
                </Grid>
                <Grid md={1} item></Grid>
                <Grid md={3} item textAlign="center">
                  <Typography variant="label">
                    {t("mygoal.label.actualMax")}
                  </Typography>
                </Grid>

                {scaleLevel.map((scale, idx) => {
                  return (
                    <Grid container key={idx}>
                      <Grid md={12} item mt={1.5} mb={1.5}>
                        <Divider />
                      </Grid>
                      <Grid md={2} item textAlign="center">
                        <Typography variant="label">
                          {idx + 1}
                        </Typography>
                      </Grid>
                      <Grid md={2} item></Grid>
                      <Grid md={3} item>
                        {goalMetric == 'Date'
                          ?
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              disablePast
                              value={scale.min}
                              onChange={(value) => changeValue(value, `scaleMin${idx + 1}`)}
                              minDate={idx == 0 ? null : orderScale == 'asc' ? addDate(scaleLevel[idx - 1].max, 1) : null}
                              maxDate={idx == 0 ? null : orderScale == 'asc' ? scale.max == null ? null : scale.max : addDate(scaleLevel[idx - 1].max, -1)}
                              renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                              label="Select min date"
                              format="dd/MM/yyyy"
                              disabled={scaleEdit == false ? true : idx == 0 ? null : scaleLevel[idx - 1].max == null}
                            />
                          </LocalizationProvider>
                          :
                          <TextField disabled={!scaleEdit} id="outlined-basic" value={scale.min} onChange={(e) => changeValue(e.target.value, `scaleMin${idx + 1}`)} placeholder={`e.g. ${scaleCondition[idx].min}`} variant="outlined" required fullWidth size="small" />
                        }
                      </Grid>
                      <Grid md={1} item></Grid>
                      <Grid md={3} item>
                        {goalMetric == 'Date'
                          ?
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              disablePast
                              value={scale.max}
                              minDate={idx == 0 ? null : orderScale == 'asc' ? addDate(scale.min, 1) : null}
                              maxDate={idx == 0 ? null : orderScale == 'asc' ? null : addDate(scale.min, -1)}
                              onChange={(value) => changeValue(value, `scaleMax${idx + 1}`)}
                              renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                              label="Select max date"
                              format="dd/MM/yyyy"
                              disabled={scaleEdit == false ? true : scale.min == null}
                            />
                          </LocalizationProvider>
                          :
                          <TextField disabled={!scaleEdit} id="outlined-basic" value={scale.max} onChange={(e) => changeValue(e.target.value, `scaleMax${idx + 1}`)} placeholder={`e.g. ${scaleCondition[idx].max}`} variant="outlined" required fullWidth size="small" />
                        }
                      </Grid>
                    </Grid>
                  )
                })}
              </Grid>
            </Box>
          }
          <Box backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 50 }} mb={3}>
            <Grid container justifyContent="space-between">
              <Grid item mb={2}>
                <Typography fontSize={22} fontWeight={600}>
                  {t("mygoal.label.goalCategory")}
                </Typography>
              </Grid>
              {categoryEdit
                ?
                <Grid>
                  <Button
                    size="small"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={() => cancelField('categoryEdit')}
                    color="red"
                    variant="contained"
                    style={{ marginRight: '10px', textTransform: 'none' }}
                  >
                    <CloseIcon />
                    <Typography ml={1}>{t("mygoal.label.cancel")}</Typography>
                  </Button>
                  <Button
                    size="small"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    color="primary"
                    variant="contained"
                    style={{ marginRight: '10px', textTransform: 'none' }}
                    onClick={() => checkField('categoryEdit')}
                  >
                    <SaveIcon />
                    <Typography ml={1}>{t("mygoal.label.save")}</Typography>
                  </Button>
                </Grid>
                :
                <Grid item mb={2} style={{ cursor: 'pointer' }} onClick={() => editClick('categoryEdit')}>
                  <Typography color="primary">
                    {t("mygoal.label.edit")}
                  </Typography>
                </Grid>
              }
            </Grid>
            <Grid container spacing={2}>
              {goalCategoryOptions.map((categories, idx) => {
                return (
                  <Grid lg={2} xs={12} key={idx} item>
                    <Card style={goalCategory === categories.id ? { border: '1px solid #5DA196' } : { border: null } && categoryEdit ? { cursor: 'pointer' } : { cursor: "not-allowed" }} onClick={() => { chooseCategory(categories.id) }}>
                      <CardContent>
                        <Grid item lg={12} xs={12} container textAlign="center">
                          <Grid item>
                            <Radio name="radio" value="1" checked={goalCategory === categories.id} size="small" />
                          </Grid>
                          <Grid item lg={12}>
                            <Icon style={{ color: categories.color, fontSize: 40 }}>{categories.icon}</Icon>
                          </Grid>
                          <Grid item lg={12} mt={3}>
                            <Typography fontSize={16} lineHeight="21px" fontWeight="600">
                              {categories.nameEN}
                            </Typography>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                )
              })}
              <Grid lg={12} xs={12} item>
                <Typography>
                  {requireField("Evaluation weight")}
                </Typography>
              </Grid>
              <Grid lg={7} xs={12} item>
                <Grid container direction="row">
                  <Grid lg={11}>
                    <TextField disabled={!categoryEdit} error={verifyField.weight} id="weight" placeholder="Fill your evaluation weight" value={weight} onChange={(e) => changeValue(e.target.value, 'weight')} variant="outlined" required fullWidth size="small" style={{ marginLeft: 10, marginTop: 8 }} />
                  </Grid>
                  <Grid ml={2} mt={2}>
                    <Typography>
                      %
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              {(!weight) &&
                <Grid lg={5}>
                </Grid>
              }
              {(categoryWeight - weight >= 0 && weight > 0) &&
                <Grid lg={5} alignSelf="center" style={{ paddingTop: '20px' }}>
                  <Grid container direction="row">
                    <Grid style={{ paddingRight: '5px' }}>
                      <Icon style={{ color: '#5DA196' }}>{'check_circle'}</Icon>
                    </Grid>
                    <Grid lg={11}>
                      <Typography style={{ color: '#5DA196' }}>
                        {`This evaluation weight can be used.`}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              }
              {(categoryWeight - weight < 0 && weight > 0) &&
                <Grid lg={6} alignSelf="center" style={{ paddingTop: '20px' }}>
                  <Grid container direction="row">
                    <Grid style={{ paddingRight: '5px' }}>
                      <Icon style={{ color: '#CC6058' }}>{'cancel'}</Icon>
                    </Grid>
                    <Grid lg={11}>
                      <Typography style={{ color: '#CC6058' }}>
                        {`The total score is above the limit by ${weight - categoryWeight} %`}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              }
              <Grid lg={5} xs={12} item>
                <Typography>
                  {'The total weights of each goals category is limited to 100% '}
                </Typography>
              </Grid>
              <Grid lg={2} xs={12} item alignItems="flex-end">
                <Grid container direction="row" justifyContent={'flex-end'}>
                  <Typography>
                    {t("mygoal.label.remaining")}
                  </Typography>
                  <Typography ml={1} style={{ color: categoryWeight - weight >= 0 ? '#5DA196' : categoryWeight - weight < 0 ? '#CC6058' : 'black' }}>
                    {`${categoryWeight - weight} % `}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Box>
          <Box backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 50 }} mb={3}>
            <Grid container justifyContent="space-between" direction="row">
              <Grid item mb={2}>
                <Typography fontSize={22} fontWeight={600}>
                  {t("mygoal.label.goalAlignment")}
                </Typography>
              </Grid>
              {alignmentEdit
                ?
                <Grid item>
                  <Grid container direction="row">
                    <Grid item>
                      <Typography style={{ color: '#CC6058', textDecoration: 'underline', cursor: 'pointer' }} mr={2} mt={1} onClick={() => { setGoalAlingment(null); setAlignmentEdit(false) }}>
                        Remove Alignment
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Button
                        size="small"
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={() => cancelField('alignmentEdit')}
                        color="red"
                        variant="contained"
                        style={{ marginRight: '10px', textTransform: 'none' }}
                      >
                        <CloseIcon />
                        <Typography ml={1}>{t("mygoal.label.cancel")}</Typography>
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        size="small"
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        color="primary"
                        variant="contained"
                        style={{ marginRight: '10px', textTransform: 'none' }}
                        onClick={() => checkField('alignmentEdit')}
                      >
                        <SaveIcon />
                        <Typography ml={1}>{t("mygoal.label.save")}</Typography>
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                :
                (goalAlignment !== null && goalAlignment !== undefined) &&
                <Grid item mb={2} style={{ cursor: 'pointer' }} onClick={() => editClick('alignmentEdit')}>
                  <Typography color="primary">
                    {t("mygoal.label.edit")}
                  </Typography>
                </Grid>
              }
            </Grid>
            {(goalAlignment !== null && goalAlignment !== undefined)
              ?
              <Grid container spacing={2}>
                {(!alignmentEdit && goalAlignment == 1 || alignmentEdit) &&
                  <Grid lg={2} xs={12} item>
                    <Card style={goalAlignment === 1 ? { border: '1px solid #5DA196', cursor: 'pointer' } : { border: null, cursor: 'pointer' }} onClick={() => { changeAlignment(1) }}>
                      <CardContent>
                        <Grid item lg={12} xs={12} container textAlign="center">
                          <Grid item>
                            <Radio name="radio" value="1" checked={goalAlignment === 1} size="small" />
                          </Grid>
                          <Grid item lg={12} mt={3}>
                            {goalAlignment == 1 ? <LinkActive /> : <LinkInactive />}
                          </Grid>
                          <Grid item lg={12} mt={5}>
                            <Typography fontSize={16} lineHeight="21px" fontWeight="600">
                              {'Linking Goal'}
                            </Typography>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                }
                {(!alignmentEdit && goalAlignment == 2 || alignmentEdit) &&
                  <Grid lg={2} xs={12} item>
                    <Card style={goalAlignment === 2 ? { border: '1px solid #5DA196', cursor: 'pointer' } : { border: null, cursor: 'pointer' }} onClick={() => { changeAlignment(2) }}>
                      <CardContent>
                        <Grid item lg={12} xs={12} container textAlign="center">
                          <Grid item>
                            <Radio name="radio" value="2" checked={goalAlignment === 2} size="small" />
                          </Grid>
                          <Grid item lg={12}>
                            {goalAlignment == 2 ? <CasActive /> : <CasInactive />}
                          </Grid>
                          <Grid item lg={12} mt={3}>
                            <Typography fontSize={16} lineHeight="21px" fontWeight="600">
                              {'Cascading Goal'}
                            </Typography>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                }
                <Grid lg={12} xs={12} item>
                  <Typography>
                    {goalAlignment == 1 ? requireField('Linking Goal Type') : requireField('Assigned Type')}
                  </Typography>
                </Grid>
                <Grid lg={12} xs={12} item>
                  <FormControl sx={{ m: 1, minWidth: 80 }} fullWidth>
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-autowidth-label"
                      id="demo-simple-select-autowidth"
                      value={type}
                      onChange={(val) => { handleChange(val.target.value, 'type') }}
                      input={<OutlinedInput size="small" />}
                      renderValue={(selected) => {
                        if (selected?.length == 0) {
                          return <em>{goalAlignment == 1 ? 'Select linking goal type' : 'Select assigned type'}</em>;
                        } else {
                          return selected
                        }
                      }}
                      disabled={!alignmentEdit}
                    >
                      <MenuItem disabled value="">
                        <em>{goalAlignment == 1 ? 'Select linking goal type' : 'Select assigned type'}</em>
                      </MenuItem>
                      {selectOption.type?.map((option, idx) => {
                        return <MenuItem key={idx} value={option}>{option}</MenuItem>
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid lg={12} xs={12} item>
                  <Typography>
                    {goalAlignment == 1 ? requireField('Linked goal') : requireField('Assigned members')}
                  </Typography>
                </Grid>
                <Grid lg={12} xs={12} item>
                  <FormControl sx={{ m: 1, minWidth: 80 }} fullWidth>
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-autowidth-label"
                      id="demo-simple-select-autowidth"
                      value={value}
                      multiple
                      onChange={(val) => { handleChange(val.target.value, 'value') }}
                      input={<OutlinedInput size="small" />}
                      renderValue={(selected) => {
                        if (selected?.length == 0) {
                          return <em>{goalAlignment == 1 ? 'Select your linked goal' : 'Select your assigned members'}</em>;
                        } else {
                          return <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {selected.map((value, idx) => (
                              <Chip key={idx} label={goalAlignment == 1 ? value.name : `${value.firstName} ${value.lastName ?? ''}`} style={{ borderRadius: '6px', backgroundColor: '#5DA196', color: 'white' }} />
                            ))}
                          </Box>
                        }
                      }}
                      disabled={!alignmentEdit}
                    >
                      <MenuItem disabled value="">
                        <em>{goalAlignment == 1 ? 'Select your linked goal' : 'Select your assigned members'}</em>
                      </MenuItem>
                      {goalAlignment == 1
                        ?
                        selectOption.value?.map((option, idx) => {
                          return <MenuItem key={idx} value={option}>{option.name}</MenuItem>
                        })
                        :
                        selectOption.value?.map((option, idx) => {
                          return <MenuItem key={idx} value={option}>
                            {option.firstName} {option.lastName ?? ''}
                          </MenuItem>
                        })
                      }
                    </Select>
                  </FormControl>
                </Grid>
                <Grid lg={12} xs={12} item>
                  <Typography fontSize={14} variant="label">
                    {goalAlignment == 1 ? `Linked goal: ${value.length} items` : `Assigned members: ${value.length} members`}
                  </Typography>
                </Grid>
              </Grid>
              :
              <Grid container spacing={2} style={{ justifyContent: 'center', margin: '5px' }} direction="column">
                <Grid item style={{ textAlign: 'center' }}>
                  <NoneAlignment />
                </Grid>
                <Grid item style={{ textAlign: 'center' }}>
                  <Typography variant="label" fontSize={20} >
                    This goal not link/cascade with others goals yet. {goalAlignment}
                  </Typography>
                  <Typography color="primary" fontSize={14} style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => { setGoalAlingment(1); editClick('alignmentEdit') }}>
                    Click here to add goal alignment
                  </Typography>
                </Grid>
              </Grid>
            }
          </Box>
          <Box backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 50 }} mb={3}>
            <Grid container justifyContent="space-between">
              <Grid item mb={2}>
                <Typography fontSize={22} fontWeight={600}>
                  {t("mygoal.label.evaluatorPermission")}
                </Typography>
              </Grid>
              {evaluatorEdit
                ?
                <Grid>
                  <Button
                    size="small"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={() => cancelField('evaluatorEdit')}
                    color="red"
                    variant="contained"
                    style={{ marginRight: '10px', textTransform: 'none' }}
                  >
                    <CloseIcon />
                    <Typography ml={1}>{t("mygoal.label.cancel")}</Typography>
                  </Button>
                  <Button
                    size="small"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    color="primary"
                    variant="contained"
                    style={{ marginRight: '10px', textTransform: 'none' }}
                    onClick={() => checkField('evaluatorEdit')}
                  >
                    <SaveIcon />
                    <Typography ml={1}>{t("mygoal.label.save")}</Typography>
                  </Button>
                </Grid>
                :
                <Grid item mb={2} style={{ cursor: 'pointer' }} onClick={() => editClick('evaluatorEdit')}>
                  <Typography color="primary">
                    {t("mygoal.label.edit")}
                  </Typography>
                </Grid>
              }
            </Grid>
            <Grid container spacing={2}>
              <Grid lg={12} xs={12} item>
                <Typography>
                  {t("mygoal.label.alternate")}
                </Typography>
              </Grid>
              <Grid lg={12} xs={12} item style={{ marginRight: 50 }}>
                <FormControl sx={{ m: 1, minWidth: 80 }} fullWidth>
                  <Select
                    displayEmpty
                    labelId="demo-simple-select-autowidth-label"
                    id="demo-simple-select-autowidth"
                    value={evaluator}
                    onChange={(val) => { handleChange(val.target.value, 'evaluator') }}
                    input={<OutlinedInput size="small" />}
                    renderValue={(selected) => {
                      if (selected == null) {
                        return <em>Select the evaluation</em>;
                      } else {
                        return `${selected.firstName} ${selected.lastName}`;
                      }
                    }}
                    disabled={!evaluatorEdit}
                  >
                    <MenuItem disabled value="">
                      <em>Select the evaluation</em>
                    </MenuItem>
                    {selectOption.evaluator.map((option, idx) => {
                      return <MenuItem key={idx} value={option}>{`${option.firstName} ${option.lastName}`}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              </Grid>

              <Grid lg={12} xs={12} item>
                <Typography>
                  {t("mygoal.label.permission")}
                </Typography>
              </Grid>
              <Grid lg={12} xs={12} item style={{ marginRight: 50 }}>
                <FormControl sx={{ m: 1, minWidth: 80 }} fullWidth>
                  <Select
                    displayEmpty
                    labelId="demo-simple-select-autowidth-label"
                    id="demo-simple-select-autowidth"
                    value={permission}
                    onChange={(val) => { handleChange(val.target.value, 'permission') }}
                    input={<OutlinedInput size="small" />}
                    renderValue={(selected) => {
                      if (selected == null) {
                        return <em>Select the permission</em>;
                      } else {
                        return selected;
                      }
                    }}
                    disabled={!evaluatorEdit}
                  >
                    <MenuItem disabled value="">
                      <em>Select the permission</em>
                    </MenuItem>
                    {selectOption.permission.map((option, idx) => {
                      return <MenuItem key={idx} value={option}>{option}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
          <Grid container direction="row">
            <Grid container lg={1} xs={1} direction="row" style={{ alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => { openApproveDialog(true) }}>
              {pageResult &&
                <Grid item mt={0.5}>
                  <BackIcon />
                </Grid>
              }
              <Grid item ml={1}>
                <Typography>
                  Back
                </Typography>
              </Grid>
            </Grid>
            <Grid lg={10} xs={12} item textAlign="center">
              <Button
                size="small"
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={() => { confirmPage() }}
                color="primary"
                variant="contained"
                style={{ paddingLeft: 30, paddingRight: 30, textTransform: 'none' }}
              >
                <Typography>{pageResult ? 'Create Goal' : 'Save'}</Typography>
              </Button>
            </Grid>
          </Grid>
          <WarningDialog open={isApproveDialogOpen} doConfirm={handleConfirmApprove} setValue={handleConfirmApproveDialog} title="Discard Change?" text="You’ll lose all filled informantion. We can’t recover them once you changed. Are you sure you want to discard changes made on this page ?" />
        </Container>
      </Box>
    </>
  );
};
export default MyGoalCreateResult;
